export default "__VITE_ASSET__B6lo5prm__"